// Page 1 has no page parameter, so the address matches the canonical URL.
function setPageParam(params, page) {
  if (parseInt(page) > 1) {
    params.set("page", page);
  } else {
    params.delete("page");
  }
}

class LoadingButton extends HTMLElement {
  constructor() {
    super();
    this.url = "";
    this.totalProducts = 0;
    this.loadedProducts = 0;
    this.loadPrevious = this.dataset.load === "previous";
    if (!this.loadPrevious) {
      this.progressBar = this.querySelector(".progress-bar");
      this.progressBar.value = this.loadedProducts;
      this.resultsCountElems = document.querySelectorAll(".result-count");
      this.productContainer = document.querySelector("#product-grid");
    }
    this.automaticLoading = this.getAttribute("automatic-loading");
    this.loadButton = this.querySelector("button");
    this.loadButtonContainer = this.closest(".pagination-wrapper");
    this.articleContainer = document.querySelector("#article-grid");
    this.vanillaPagination = document.querySelector("#pagination");
    if (!this.loadPrevious) {
      this.loadButton.addEventListener("click", () => {
        this.loadMore();
      });
    }
    document.addEventListener('click', this.gridItemLinkInterceptor.bind(this));
    if (this.automaticLoading === true) {
      // loading observer
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.25,
      };
      this.observer = new IntersectionObserver(this.handleIntersection, options);
    }
  }

  connectedCallback() {
    if (this.automaticLoading === "true") {
      this.observer.observe(this.loadButton);
    }
    this.loadedProducts = parseInt(this.loadButton.getAttribute("data-loaded-products-total"));
    this.totalProducts = parseInt(this.loadButton.getAttribute("data-total-results-count"));
    this.updateProgress();
  }

  setLastVisitedProductInSessionStorage(variantID, collectionHandle) {
    sessionStorage.setItem("lastVisitedProduct", JSON.stringify({ variantID, collectionHandle }));
  }

  // intercepts product card and article card links and updates the url with the page number
  gridItemLinkInterceptor(e) {
    if (e.target.closest('.quick-add__submit')) {
      return;
    } else if (e.target.closest('product-card') && e.target.closest('#product-grid')) {
      e.preventDefault();
      const variantID = e.target.closest('li.grid__item').dataset.variantId;
      const collectionHandle = e.target.closest('#product-grid').dataset.collectionHandle;
      this.setLastVisitedProductInSessionStorage(variantID, collectionHandle);

      let url = new URL(window.location.href);
      let page = e.target.closest('li.grid__item').dataset.pageIndex;
      setPageParam(url.searchParams, page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('product-card').querySelector('a').href;
    } else if (e.target.closest('.article-card-wrapper') && e.target.closest('#article-grid')) {
      e.preventDefault();
      let url = new URL(window.location.href);
      let page = e.target.closest('.blog-articles__article').dataset.pageIndex;
      setPageParam(url.searchParams, page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('.blog-articles__article').dataset.url;
    } else {
      return;
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest("loading-button").loadMore();
      }
    });
  }

  loadMore() {
    this.url = document.querySelector(".pagination-wrapper a.pagination__item--next").href;
    this.loadButton.classList.add("loading");
    this.fetchItems(this.url);
  }

  fetchItems(url, loadPrevious) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        if (url.includes("blog")) {
          this.renderArticleGrid(html, loadPrevious);
          window.history.pushState({}, "", url);
          if (!loadPrevious) {
            this.renderNewNavigation(html);
          }
          this.loadingButtonChecker();
        } else {
          window.history.pushState({}, "", url);

          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, "text/html");

          this.renderProductGrid(html);
          this.renderNewNavigation(html);
          this.loadingButtonChecker();
          this.updateProgress();
        }
      });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, "text/html").getElementById("product-grid").innerHTML;
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
    this.loadedProducts = this.productContainer.querySelectorAll(".product").length;

    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('layout:updated'));
    });

    this.renderWishlistButtons();
  }

  renderWishlistButtons() {
    let productGridSelector = "main #product-grid";

    document.dispatchEvent(
      new CustomEvent("swym:refresh-products", {
        detail: {
          selector: productGridSelector,
        },
      })
    );
  }

  renderArticleGrid(html, loadPrevious) {
    let newPage = new DOMParser().parseFromString(html, "text/html").getElementById("article-grid").innerHTML;
    if (loadPrevious) {
      this.articleContainer.innerHTML = newPage + this.articleContainer.innerHTML;
    } else {
      this.articleContainer.innerHTML = this.articleContainer.innerHTML + newPage;
    }
    this.loadedArticles = this.articleContainer.querySelectorAll(".article").length;
  }

  renderNewNavigation(html) {
    const newPagination = new DOMParser().parseFromString(html, "text/html").getElementById("pagination")?.innerHTML;
    if (newPagination) {
      this.vanillaPagination.innerHTML = newPagination;
    } else {
      this.loadButtonContainer.innerHTML = "";
    }
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove("loading");

    const urlParams = new URLSearchParams(window.location.search);
    const pageIndex = parseInt(urlParams.get("page") || "1");

    const directionLength = !this.loadPrevious ? document.querySelectorAll(".pagination-wrapper a.pagination__item--next").length : pageIndex;
    if (this.loadPrevious && pageIndex === 1) {
      this.classList.add("hidden");
      return;
    }

    if (directionLength === 0) {
      this.loadButtonContainer.classList.add("hidden");
    }
  }

  updateProgress() {
    let visibleProducts = document.querySelectorAll("#product-grid > li:not(.hidden,.featured-card)");
    let progress = (visibleProducts.length / this.totalProducts) * 100;
    this.progressBar.setAttribute("style", "--progress:" + `${progress}` + "%");
    this.resultsCountElems.forEach((elem)  => {
      elem.innerHTML = elem.dataset.textTemplate.replace("[LOADED]", visibleProducts.length).replace("[TOTAL]", this.totalProducts);
    })
  }
}

customElements.define("loading-button", LoadingButton);

class LoadPreviousProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.loadPrevious.bind(this));
    document.addEventListener("previous-items-loaded", this.updateLoadMoreProgressCount.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("previous-items-loaded", this.updateLoadMoreProgressCount.bind(this));
  }

  updateLoadMoreProgressCount() {
    let loadMoreButton = document.querySelector("loading-button");

    if (loadMoreButton) {
      loadMoreButton.updateProgress();
    } else {
      const resultCount = document.querySelector(".result-count");
      const totalProducts = resultCount.dataset.totalProducts;
      resultCount.innerHTML = resultCount.dataset.textTemplate.replace("[LOADED]", totalProducts).replace("[TOTAL]", totalProducts);
    }
  }

  getPreviousPageIndex() {
    let previousPageIndex = parseInt(this.pageIndex) - 1;

    if (previousPageIndex <= 1) {
      return 1;
    } else {
      return previousPageIndex;
    }
  }

  loadPrevious() {
    this.classList.add("loading");

    this.pageIndex = this.dataset.pageIndex;

    let url = window.location.href;
    let params = new URLSearchParams(window.location.search);
    let previousPageIndex = this.getPreviousPageIndex();

    setPageParam(params, previousPageIndex);

    const query = params.toString();
    window.history.pushState({}, "", query ? `${url.split("?")[0]}?${query}` : url.split("?")[0]);

    document.querySelector("facets-filters-form")?.getPreviousData();

    this.dataset.pageIndex = previousPageIndex;
  }
}

customElements.define("load-previous-products", LoadPreviousProducts);

class LoadingPreviousArticles extends LoadingButton {
  constructor() {
    super();
    this.loadButton = this;
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      this.loadPreviousArticles();
    });
  }

  loadPreviousArticles() {
    this.classList.add("loading");

    const currentPageIndex = parseInt(this.dataset.pageIndex);
    const previousPageIndex = currentPageIndex - 1;

    let url = window.location.href;
    url = url.split("?")[0];
    url = url.replace(/&?page=\d+/, "");
    if (previousPageIndex > 1) {
      url = url + `?page=${previousPageIndex}`;
    }

    this.dataset.pageIndex = previousPageIndex;

    this.fetchItems(url, true);
  }
}

customElements.define("load-previous-articles", LoadingPreviousArticles);

window.onpageshow = function(event) {
  if (event.persisted) {
  ScrollRestoration();
  } else {
  ScrollRestoration();
  }
};

function ScrollRestoration () {
  if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
  }

const lastVisitedProductOnPCP = JSON.parse(sessionStorage.getItem('lastVisitedProduct'));
const collectionHandle = document.querySelector('#product-grid')?.dataset?.collectionHandle;

if (collectionHandle && lastVisitedProductOnPCP && lastVisitedProductOnPCP.collectionHandle === collectionHandle) {
    const lastVisitedProduct = document.querySelector(`[data-variant-id="${lastVisitedProductOnPCP.variantID}"]`);

if (lastVisitedProduct) {
  setTimeout(() => {
    lastVisitedProduct.scrollIntoView({
      block: 'center'
    });
  });
    }
  }

sessionStorage.removeItem('lastVisitedProduct');
}
